import * as React from "react";
import { RouteComponentProps, withRouter } from "react-router";

import { WebComponents, AlertType } from "@/interfaces";
import { AlertList } from "@/components/Lists/AlertList";
import { useAccountSettings } from "@/utils";

import "./styles.scss";
import { PageWrapper } from "@/components/PageWrapper";
import { Tabs } from "@/components/ui/tabs";

type Props = RouteComponentProps;

const AlertsFC: React.FC<Props> = () => {
  const { hasWritePermission } = useAccountSettings();
  const withWritePermission = hasWritePermission(WebComponents.ALERTS);

  return (
    <PageWrapper title="Alerts" hideSeparator={true}>
      <div className="alertsListRowContainer">
        <Tabs defaultValue="player-not-posting" className="basicPadding w-full">
          <Tabs.List variant="menu">
            <Tabs.Trigger value="player-not-posting">Player Not Posting</Tabs.Trigger>
            <Tabs.Trigger value="campaign-about-to-expire">Campaign About to Expire</Tabs.Trigger>
            <Tabs.Trigger value="social-network-problems">Social Network Issues</Tabs.Trigger>
            <Tabs.Trigger value="post-failed">Post Failed</Tabs.Trigger>
          </Tabs.List>

          <Tabs.Content value="player-not-posting">
            <AlertList type={AlertType.PLAYER_NO_POSTING} withWritePermission={withWritePermission} defaultPage={0} />
          </Tabs.Content>

          <Tabs.Content value="campaign-about-to-expire">
            <AlertList
              type={AlertType.CAMPAIGN_ABOUT_TO_EXPIRED}
              withWritePermission={withWritePermission}
              defaultPage={0}
            />
          </Tabs.Content>

          <Tabs.Content value="social-network-problems">
            <AlertList type={AlertType.SN_ERROR} withWritePermission={withWritePermission} defaultPage={0} />
          </Tabs.Content>

          <Tabs.Content value="post-failed">
            <AlertList type={AlertType.POST_FAILED} withWritePermission={withWritePermission} defaultPage={0} />
          </Tabs.Content>
        </Tabs>
      </div>
    </PageWrapper>
  );
};

export const AlertsSection = withRouter(AlertsFC);
